import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Hero = () => {
  return (
    <section id="hero" className="min-h-screen bg-white flex items-center pt-20 md:pt-0 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-gray-50 to-white opacity-50" />
      <div className="container mx-auto px-6 md:px-4 relative">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="flex flex-col md:flex-row items-center justify-center md:space-x-12"
        >
          {/* Image Section */}
          <motion.div 
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
            className="w-48 md:w-72 mb-8 md:mb-0 hover:transform hover:scale-105 transition-transform duration-300"
          >
            <img 
              src="logoctc2.png" 
              alt="Logo" 
              className="w-full h-auto border-r-4 border-b-4 border-black" 
            />
          </motion.div>
          
          {/* Text and Button Section */}
          <div className="max-w-lg text-center md:text-left">
            <div className="mb-4">
              <motion.h1 
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.4, duration: 0.5 }}
                className="text-5xl md:text-7xl font-medium text-gray-800 mb-2 font-trends"
              >
                Chase
                <motion.p 
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.6, duration: 0.5 }}
                  className="text-xl md:text-2xl font-medium text-gray-800 font-trends my-1"
                >
                  the
                </motion.p>
                <motion.p 
                  initial={{ opacity: 0, x: 20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.8, duration: 0.5 }}
                  className="text-5xl md:text-7xl font-medium text-gray-800 font-trends"
                >
                  Chickens
                </motion.p>
              </motion.h1>
            </div>
            <motion.p 
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 1, duration: 0.5 }}
              className="text-lg md:text-xl text-gray-600 mb-8 md:mb-6"
            >
              Catch them if you can! The ultimate chicken chase awaits!
            </motion.p>
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 1.2, duration: 0.5 }}
              className="flex justify-center md:justify-start"
            >
              <Link to="/download">
                <button className="bg-[#E57373] text-white rounded-full px-8 py-4 text-lg md:text-md font-medium transition duration-300 transform hover:scale-105 hover:shadow-lg">
                  Download Now
                </button>
              </Link>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;